// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"29673f92","977":"36d886f8"}[chunkId] + ".chunk.js";
};